module.exports = __webpack_public_path__ + "static/media/us-land-shop-about-us.ad1e0780.jpg";